import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsWidgetLegendContent} from "./standings-widget.legend-content";
import {StandingsWidgetController} from "../../standings-widget.controller";

class StandingsWidgetLegendFooterProps extends BaseProps {
  controller: StandingsWidgetController;
  className: String;
}

export const StandingsWidgetLegendFooter = ({controller, className}: StandingsWidgetLegendFooterProps) => {
  return controller.state.shouldRenderLegendFooter ? <StandingsWidgetLegendContent controller={controller} className={className}/> : null
  }
